module['exports'] = ['+92 ###-###-####', '03## ### ####', '03#########'];
